import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { Radio, Clock, Circle, Dribbble, ArrowRight } from 'lucide-react';
import SEO from '../components/SEO';

const SporBahisleri: React.FC = () => {
  const categories = [
    {
      title: 'Canlı',
      description: 'Canlı maçlara bahis yapın',
      icon: Radio,
      path: '/spor-bahisleri/canli',
      color: 'from-red-500 to-rose-500'
    },
    {
      title: 'Yaklaşan',
      description: 'Yaklaşan maçları inceleyin',
      icon: Clock,
      path: '/spor-bahisleri/yaklasan',
      color: 'from-blue-500 to-cyan-500'
    },
    {
      title: 'Futbol',
      description: 'Futbol bahisleri',
      icon: Circle,
      path: '/spor-bahisleri/futbol',
      color: 'from-green-500 to-emerald-500'
    },
    {
      title: 'Basketbol',
      description: 'Basketbol bahisleri',
      icon: Dribbble,
      path: '/spor-bahisleri/basketbol',
      color: 'from-orange-500 to-amber-500'
    }
  ];

  return (
    <>
      <SEO
        title="Spor Bahisleri | Canlı ve Pre-Match"
        description="Futbol, basketbol ve daha fazlasına bahis yapın. Canlı ve yaklaşan maçlar."
        url="/spor-bahisleri"
      />
      <div className="min-h-screen bg-dark-900 pt-24 pb-12">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            className="text-center mb-12"
          >
            <h1 className="text-4xl md:text-5xl font-bold text-white mb-4">
              Spor Bahisleri
            </h1>
            <p className="text-xl text-gray-400 max-w-2xl mx-auto">
              En iyi oranlarla spor bahisleri
            </p>
          </motion.div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
            {categories.map((category, index) => {
              const Icon = category.icon;
              return (
                <motion.div
                  key={index}
                  initial={{ opacity: 0, y: 30 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.6, delay: index * 0.1 }}
                >
                  <Link
                    to={category.path}
                    className="group block bg-dark-800/50 backdrop-blur-sm rounded-2xl p-6 border border-dark-700 hover:border-primary-500/50 transition-all duration-300 h-full"
                  >
                    <div className={`w-16 h-16 mx-auto mb-4 rounded-xl bg-gradient-to-r ${category.color} flex items-center justify-center group-hover:scale-110 transition-transform duration-300`}>
                      <Icon className="w-8 h-8 text-white" />
                    </div>
                    <h2 className="text-xl font-bold text-white text-center mb-2 group-hover:text-primary-400 transition-colors">
                      {category.title}
                    </h2>
                    <p className="text-gray-400 text-center text-sm mb-4">
                      {category.description}
                    </p>
                    <div className="flex items-center justify-center text-primary-400 group-hover:text-primary-300">
                      <span className="mr-2 text-sm">Keşfet</span>
                      <ArrowRight className="w-4 h-4 group-hover:translate-x-1 transition-transform" />
                    </div>
                  </Link>
                </motion.div>
              );
            })}
          </div>
        </div>
      </div>
    </>
  );
};

export default SporBahisleri;
